module.exports = __webpack_public_path__ + "static/media/nexttel-wide-logo.7c645abf.png";